import { Pipe, PipeTransform } from '@angular/core';
//import * as moment from 'moment';

@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {

  transform(value: any, separator="", string): string {
    return value.map(x => x.id).join(separator).toString();
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/pipes/join.pipe.ts